import { useState } from "react";
import { Popover } from "antd";
import CopyToClipboard from "react-copy-to-clipboard";

import copy from "../../assets/images/webToLead/copy.png";

const CopyText = ({ text, content, callback, size }) => {
  const [copied, setCopied] = useState(false);

  return (
    <Popover
      content={<div className="text-white">copied</div>}
      color="#5D44FF"
      open={copied}
    >
      <CopyToClipboard
        text={text}
        onCopy={() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 1000);
          callback && callback();
        }}
      >
        {content ? (
          content
        ) : (
          <img
            src={copy}
            alt=""
            width={size ? size : 20}
            height={size ? size : 20}
            style={{
              width: size ? size : 20,
              height: size ? size : 20,
            }}
            className="cursor-pointer"
          />
        )}
      </CopyToClipboard>
    </Popover>
  );
};

export default CopyText;
